<template>
	<div>
	  <div class="row">
		<div class="col-md-12">
		  <div class="card">
			<div class="card-header">
				<div class="row">
				  <div class="col-md-4">
					<h5 class="title">{{ $t( "contacts.contacts") }}</h5>
				  </div>
				  <div class="col-md-4">
				  <div class="text-center spinner-container" v-if="!contacts.loaded">
					<div class="spinner-border" role="status">
					  <span class="sr-only">{{ $t( "general.loading") }}</span>
					</div>
				  </div>
				  </div>
				  <div class="col-md-4 action-buttons-col">
					<p-button class="" type="info" @click="refreshData()">
					  <i class="fa fa-sync-alt"></i>
					  </p-button>
					<p-button class="" type="success" :title='$t( "contacts.addNew")' @click="newContact()">
					  <i class="fa fa-user-plus"></i>
					  </p-button>
				  </div>
				</div>
			</div>

			<div class="table-responsive table-full-width" v-if="user && user.data && contacts.loaded">
			  <el-table
				v-if="contacts.loaded"
				:default-sort = "{prop: 'value', order: 'ascending'}"
				class="table-expandable"
				:data="contactsFull ? contactsFull : contacts.data.contacts"
				ref="tableFleet"
				style="width: 100%">
				<el-table-column v-if="user.admin"
				  sortable
				  :label='$t( "contacts.partner")'
				  prop="partnerId">
				</el-table-column>
				<el-table-column
				  sortable
				  align="right"
				  :label='$t( "contacts.firstName")'
				  prop="firstName">
				</el-table-column>
				<el-table-column
				  sortable
				  :label='$t( "contacts.lastName")'
				  prop="lastName">
				</el-table-column>
				<el-table-column
				    :label='$t( "contacts.driving")'>
                    <template slot-scope="scope">
                        <a href="#" @click.prevent="openContract(scope.row.vehicleId)">{{scope.row.vehicleName}}</a>
                    </template>
                >
				</el-table-column>
				<el-table-column
				  sortable
				  :label='$t( "contacts.email")'
				  prop="contactEmail">
				</el-table-column>
				<el-table-column
				  sortable
				  :label='$t( "contacts.mobile")'
				  prop="mobile">
				</el-table-column>
				<el-table-column
				  sortable
				  :label='$t( "contacts.note")'
				  prop="portalNote">
				</el-table-column>
				<el-table-column
				  sortable
				  :label='$t( "contacts.created")'
				  :formatter="(r, c, val, i) => formatDate(val)"
				  prop="created">
				</el-table-column>
				<el-table-column :label='$t( "contacts.action")' align="center" v-if="user.data.role ==='PM'">
				  <template slot-scope="scope">
					<p-button class="action-button" type="danger" size="sm" icon :title='$t( "contacts.markAsExEmployee")' @click="reject(scope.$index, scope.row)">
					  <i class="fa fa-user-minus"></i>
					</p-button>
					<p-button class="action-button" type="warning" size="sm" icon :title='$t( "general.edit")' @click="editContact(scope.$index, scope.row)">
					  <i class="fa fa-user-edit"></i>
					</p-button>
				  </template>
				</el-table-column>
			  </el-table>
			</div>
		  </div>
		</div>
	  </div>
        <modal :show.sync="contactCreateEdit"
			footer-classes="justify-content-center"
			type="notice"
			v-on:close="onModalClose"
		>

        <h5 slot="header" class="modal-title" v-if="contactCreateEditData._id">{{ $t( "contacts.editContact") }}</h5>
        <h5 slot="header" class="modal-title" v-else>{{ $t( "contacts.newContact") }}</h5>

        <template>
			<form class="form-horizontal">
				<div class="row">
					<label class="col-md-3 col-form-label">{{ $t( "contacts.firstName") }}</label>
					<div class="col-md-9">
						<fg-input
							v-model="contactCreateEditData.firstName"
							v-validate="modelValidations.firstName"
							type="text"
                            name="First name"
							:placeholder='$t( "general.inputPlaceholderType")'
                     		:error="getError('First name')"
						></fg-input>
					</div>
					<label class="col-md-3 col-form-label">{{ $t( "contacts.lastName") }}</label>
					<div class="col-md-9">
						<fg-input
							v-model="contactCreateEditData.lastName"
							v-validate="modelValidations.lastName"
							type="text"
                     		name="Last name"
							:placeholder='$t( "general.inputPlaceholderType")'
                     		:error="getError('Last name')"
						></fg-input>					</div>
					<label class="col-md-3 col-form-label">{{ $t( "contacts.email") }}</label>
					<div class="col-md-9">
						<fg-input
							v-model="contactCreateEditData.contactEmail"
							v-validate="modelValidations.contactEmail"
							type="text"
                     		name="Email"
							:placeholder='$t( "general.inputPlaceholderType")'
                     		:error="getError('Email')"
						></fg-input>					</div>
					<label class="col-md-3 col-form-label">{{ $t( "contacts.mobile") }}</label>
					<div class="col-md-9">
					    <div class="form-group"
                            :class="[
                                {'has-danger': getError('Mobile')}
                            ]">
                            <input
                                class="form-control"
                                :class="[{'is-valid': !getError('Mobile')}, {'is-invalid': getError('Mobile')}]"
                                type="text"
                                name="Mobile"
                                placeholder="+38..."
                                v-validate:mobileUnmasked="modelValidations.mobile"
                                :error="getError('Mobile')"
                                :value="contactCreateEditData.mobile"
                                v-imask="mask"
                                @accept="onAccept($event)"
                                @complete="onComplete"
                                :unmask="true"
                                unmaskedValue
                            />
                            <div class="invalid-feedback error-text"  v-if="true">
                                {{ getError('Mobile') }}
                            </div>
					    </div>
                    </div>
					<label class="col-md-3 col-form-label">{{ $t( "contacts.note") }}</label>
					<div class="col-md-9">
						<fg-input v-model="contactCreateEditData.portalNote" :placeholder='$t( "general.inputPlaceholderType")'></fg-input>
					</div>

					<!-- <label class="col-md-3 col-form-label"></label>
					<div class="col-md-9">
						<fg-input placeholder="Password">
							<p-checkbox>Remember me</p-checkbox>
						</fg-input>
					</div> -->
				</div>
			</form>
        </template>
        <div slot="footer" class="justify-content-center">
          <p-button type="info" round @click.native="upsertContact">{{!contactCreateEditData._id ? $t( "contacts.createNewContact"): $t( "contacts.updateContact")}}</p-button>
        </div>
      </modal>
	</div>
</template>
<script>

  import Vue from 'vue'
  import moment from 'moment'
  import swal from 'sweetalert2'

  import {Table, TableColumn, Input} from 'element-ui'
  import {Button, Card, Modal} from 'src/components/UIComponents'
  import alerts from 'src/util/alerts.js'
  import {IMaskDirective} from 'vue-imask';



  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Input)
  Vue.use(Button)

  export default {
	components: {
	  [Button.name]: Button,
	  Card,
      Modal
	},
	data () {
		return {
			contactCreateEdit: false,
            contactCreateEditData: {},
            mobileUnmasked: '',
			modelValidations: {
                firstName: {
                    required: true
				},
				lastName: {
                    required: true,
				},
				mobile: {
                    required: true,
                    min: 11
				},
				contactEmail: {
                    required: true,
					email: true
				}
            },
            mask: {
                mask: '+{380}(00)000-0000',
                lazy: true
            },
            onAccept (e) {
                const maskRef = e.detail;
                this.contactCreateEditData.mobile = maskRef._value;
                this.mobileUnmasked = maskRef._unmaskedValue;
            },
            onComplete (e) {
                const maskRef = e.detail;
            }
		}
	},
	mounted() {
        if (!this.$store.contacts.store.contacts.loaded) this.$store.contacts.actions.getContacts();
        if (!this.$store.fleet.store.fleetData.loaded) this.$store.fleet.actions.getFleet();


	},
	computed: {
        contacts: function() { return this.$store.contacts.store.contacts },
        contractSelected: function() { return this.$store.fleet.store.fleetData.contractSelected },
		contactsFull: function() { return this.$store.contacts.mutations.getContactsFull() },
        user: function() { return this.$store.user }
	},
	methods: {
		refreshData() {
			this.$store.contacts.actions.getContacts();
		},
		formatDate(date) {
			if (!date) return '-';
			return moment(date).format('DD.MM.YYYY');
		},
		formatTime(date) {
			if (!date) return '-';
			date = moment(date);
			return `${date.format('HH:mm')}`
		},
		formatMileage(mileage) {
			if (!mileage || mileage === 'null' || mileage === '-') return '-';
			mileage = Math.round(mileage);
			mileage = mileage.toString();
			if (mileage !== '' || mileage !== undefined || mileage !== 0  || mileage !== '0' || mileage !== null) {
			return mileage.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
			}
			return mileage
		},
		formatDateTime(date) {
			if (!date) return '-';
			return `${this.formatDate(date)} ${this.formatTime(date)}`
		},
		formatDateChat(date) {
			if (!date) return '-';
			date = moment(date);
			if (date.isSame(moment(), 'day')) return 'today, '
			return `${date.format('ddd').replace('.', '')}, ${date.format('DD.MM.YY')}`
		},
		onModalClose() {
			console.log('onModalClose');
			this.contactCreateEditData = {};
			this.errors.clear();
		},
		newContact() {
			this.contactCreateEdit = true;
		},
		editContact(i, row) {
			this.contactCreateEdit = true;
			this.contactCreateEditData = {
				firstName: row.firstName,
				lastName: row.lastName,
				contactEmail: row.contactEmail,
				mobile: row.mobile,
				portalNote: row.portalNote,
				_id: row._id
			}
		},
		upsertContact() {
			let that = this;
			console.log('contactCreateEditData', that.contactCreateEditData);
			this.$validator.validateAll().then(isValid => {
                console.log('is all valid?', isValid)
				if (!isValid) return;

				let id = that.contactCreateEditData._id;
				let labels = {
					text: this.$t('contacts.createNew'),
					confirmButtonText: this.$t('contacts.yesCreate'),
                    cancelButtonText: this.$t('general.cancel'),
					success: this.$t('contacts.newCreated'),
					error: this.$t('contacts.errorCreating')
				}
				if (id) {
					labels = {
						text: `${this.$t('contacts.update')} ${that.contactCreateEditData.firstName} ${that.contactCreateEditData.lastName}?`,
						confirmButtonText: this.$t('contacts.yesUpdate'),
                        cancelButtonText: this.$t('general.cancel'),
						success: this.$t('contacts.updated'),
						error: this.$t('contacts.errorUpdating')
					}
				}
				swal({
					title: this.$t('general.areYouSure'),
					text: labels.text,
					type: 'success',
					showCancelButton: true,
					confirmButtonClass: 'btn btn-success btn-fill',
					cancelButtonClass: 'btn btn-fill',
					confirmButtonText: labels.confirmButtonText,
          cancelButtonText: this.$t('general.cancel'),
					buttonsStyling: false
				}).then( async function (res) {
                    let respError;
                    that.contactCreateEditData.mobile = that.mobileUnmasked;
					let data = {
						contactId: id,
						changes: Object.assign({}, that.contactCreateEditData)
					}
					// existing contact
					if (id) {
						delete data.changes._id;
						respError = await that.$store.contacts.actions.modifyContact(data).catch( (err) => { console.error('problemi;', err); respError = err;});
					}
					// new contact
					else {
						respError = await that.$store.contacts.actions.insertContact(that.contactCreateEditData).catch( (err) => { console.error('problemi;', err); respError = err;});
					}
					if (respError) return alerts.error(labels.error);
					that.$store.contacts.actions.getContacts();
					document.getElementsByClassName('nc-simple-remove')[0].click();
					swal({
						title: labels.success,
						type: 'success',
						confirmButtonClass: 'btn btn-success btn-fill',
						buttonsStyling: false
					}).catch(err => {});


				}).catch(err => {})
			})
		},
		reject(i, row) {
			let that = this;
			swal({
				title: this.$t('general.areYouSure'),
				text: `${this.$t('contacts.markingEx')} "${row.firstName} ${row.lastName}" ${this.$t('contacts.markingExSufix')}`,
				type: 'warning',
				showCancelButton: true,
				confirmButtonClass: 'btn btn-danger btn-fill',
				cancelButtonClass: 'btn btn-fill',
				confirmButtonText: this.$t('general.yes'),
                cancelButtonText: this.$t('general.cancel'),
				buttonsStyling: false
			}).then(function (res) {
				let data = {
					contactId: row._id,
					changes: {isExEmployee: true}
				}
				that.$store.contacts.actions.modifyContact(data)
					.then( (error) => {
					if (error) return alerts.error(error);
					that.refreshData();
					swal({
						title: this.$t('contacts.markedAsEx'),
						type: 'success',
						confirmButtonClass: 'btn btn-success btn-fill',
						buttonsStyling: false
					}).catch(err => {});

					})
					.catch( (err) => {
						console.error('problemi;', err);
					})
				}).catch( (err) => {});
		},
		getError (fieldName) {
			return this.errors.first(fieldName)
        },
        openContract(vehicleId) {
            this.$store.fleet.store.fleetData.contractSelected = [vehicleId];
            this.$router.push('/fleet')
        }
    },
    directives: {
        imask: IMaskDirective
    }
  }

</script>
<style scoped>

  ::v-deep .card {
    background-color: transparent;
    box-shadow: unset;
  }
  ::v-deep .table-expandable tbody .el-table__row {
    background-color: white !important
  }
  ::v-deep .el-table table thead th div{
    text-overflow: clip !important;
    font-size: 0.8em;
    font-weight: bold;
    padding: 0px;
  }


  .action-buttons-col button {
	margin-left: 10px;
	float: right;
  }
  .action-buttons-col i {
	font-size: 1.5em;
  }
  .spinner-container-activity {
	margin-left: 5px;
  }
  .action-button {
	margin-left: 10px !important;
	margin-right: 10px !important;
  }
  .action-button i {
	font-size: 18px !important;
  }



</style>
